import { Box, Button } from '@mui/material'
import { Download, Window } from '@mui/icons-material'

export interface MobileControlsProps {
  handleToggle: any
}
export const MobileControls: React.FC<MobileControlsProps> = ({
  handleToggle,
}) => {

  return (
    <Box
      className="MobileControls"
      style={{
        right: '5px',
        bottom: '5px',
        position: 'fixed',
        display: 'flex',
        flexDirection: 'column-reverse',
        zIndex: 100,
      }}
    >
      <Button
        sx={{
          backgroundColor: 'black',
          opacity: 0.6,
          color: 'white',
          borderRadius: '6px',
          paddingX: '0',
          fontSize: '12px',
          marginTop: '10px',
          ':hover': {
            backgroundColor: 'black',
          },
        }}
        href="/assets/bictegravirtenofovir_alafenamideemtricitabine__master.pdf"
        download
      >
        <Download sx={{ fontSize: '30px' }} />
      </Button>
      <Button
        sx={{
          backgroundColor: 'black',
          opacity: 0.6,
          color: 'white',
          borderRadius: '6px',
          paddingX: '0',
          fontSize: '12px',
          ':hover': {
            backgroundColor: 'black',
          },
        }}
        onClick={handleToggle}
      >
        <Window sx={{ fontSize: '30px' }} />
      </Button>
    </Box>
  )
}

export default MobileControls
